import axios from "axios";
import Global from '../constant.js'

import { computed, ref } from "vue"
import { useStore } from 'vuex'
import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { useRouter } from 'vue-router'

export default function () {
  // store取得
  const $store = useStore();
  const $toast = useToast();
  const $router = useRouter();

  const newNotifications = ref([])
  const limit = ref(Global.notification_limit_per_page)
  const offset = ref(0)

  // --- computed ---
  const account = computed(() => $store.state.core.account);
  const temporaryAccount = computed(() => $store.state.core.temporaryAccount);

  // mutation操作はcommit
  const setClientErrors = (val) => $store.commit('setClientErrors', val)

  // --- methods ---
  /**
   * 
   */
  const createTemporaryAddNotification = () => {
    if (temporaryAccount.value == null) return
    axios.get(Global.url.api_temp_accounts_show + temporaryAccount.value.id)
    .then(res => {
      if (res.data.status === Global.api_status.success) {
        newNotifications.value = newNotifications.value.concat([{
          url : 'sign-in',
          message : '仮登録状態です。クリックして本登録しましょう。',
          id : temporaryAccount.value.id,
          has_img : false
        }])
        return
      }
      setClientErrors({func:"js/common/notifications.js::createTemporaryAddNotification", params: {}, errorMessage:JSON.stringify(res.data.errors)})        
    })
    .catch(error => {
      console.dir(error)
      $toast.error('client error notifications.vue at 117')
      setClientErrors({func:"js/common/notifications.js::createTemporaryAddNotification", params: {}, errorMessage:error})
    })
  }

  /**
   * 
   */
  const getCircleInvites = async () => {
    let params = {
      account_id : account.value.id,
      status : Global.circle_invite_status.pending
    }
    return await axios.post(Global.url.api_circle_invites_search_by_account, params)
    .then(res => {
      if (res.data.status === Global.api_status.success) {
        // console.dir(res.data.circle_invites)
        newNotifications.value = newNotifications.value.concat(res.data.circle_invites.map((row) => {
          return {
            id: row.id,
            url : 'circle/approval',
            account_id : row.account_id,
            message : `${row.circle_name}より招待されてます`,
            has_img : false,
            nickname : account.value.nickname
          }
        }))
        return true
      }
      return false
    })
    .catch(error => {
      console.dir(error)
      $toast.error('client error notifications.vue at 85')
      setClientErrors({func:"js/common/notifications.js::getCircleInvites", params: params, errorMessage:error})
    })
  }

  /**
   * 
   */
  const getNotifications = () => {
    let params = {
      account_id : account.value.id,
      limit : limit.value,
      offset : offset.value
    }
    axios.post(Global.url.api_entries_notifications, params)
    .then(res => {
      if (res.data.status == Global.api_status.success) {
        // console.dir(res.data.entries)
        newNotifications.value = newNotifications.value.concat(res.data.entries.map(row => {
          return {
            url : "entry",
            ...row
          } 
        }))
        if (res.data.entries.length > 0) {
          offset.value += Global.notification_limit_per_page
        }
        return
      }
    }).catch(error => {
      console.dir(error)
      $toast.error('client error notifications.vue at 169')
    })
  }

  /**
   * 
   */
  const go = (notification) => {
    if (notification.is_unread === true) {
      if (notification.notification_division_id == Global.notification_division_id.entry) _readEntry(notification)
      if (notification.notification_division_id == Global.notification_division_id.mark) _readMark(notification)
    }
    $router.push( { path : "/" + notification.url + "/" + notification.id }, () => {} )    
  }

  /**
   * 
   */
  const _readEntry = (notification) => {
    let params = {
      account_id : account.value.id,
      entry_ids : [notification.id]
    }
    axios.post(Global.url.api_already_reads_bulk_insert, params)
    .then(res => {
      if (res.data.status == Global.api_status.success) {
        newNotifications.value = []
        offset.value = 0
        getNotifications()
      }
    }).catch(error => {
      console.dir(error)
      $toast.error('client error notifications.vue at 199')
      setClientErrors({func:"js/common/notifications.js::_readEntry", params: params, errorMessage:error})
    })
  }

  /**
   * 
   */
  const _readMark = (notification) => {
    let params = {
      account_id : account.value.id,
      entry_ids : [notification.id],
      mark_ids : [notification.mark_id]
    }
    axios.post(Global.url.api_already_marks_bulk_insert, params)
    .then(res => {
      if (res.data.status == Global.api_status.success) {
        newNotifications.value = []
        offset.value = 0
        getNotifications()
      }
    })
    .catch(error => {
      console.dir(error)
      $toast.error('client error notifications.vue at 222')
      setClientErrors({func:"js/common/notifications.js::_readMark", params: params, errorMessage:error})
    })
  }

  /**
   * 
   */
  const readAll = () => {
    let params = {
      account_id : account.value.id,
      offset : 0
    }
    axios.post( Global.url.api_entries_notifications, params)
    .then(res => {
      if (res.data.status == Global.api_status.success) {
        _readAllEntry(res.data.entries)
        _readAllMark(res.data.entries)
      }
    }).catch(error => {
      console.dir(error) 
    })
  }

  /**
   * 
   */
  const _readAllEntry = (notifications) => {
    let entries = notifications.filter(x => x.notification_division_id === Global.notification_division_id.entry && x.is_unread === true)
    let entry_ids = entries.map(row => row.id)
    
    if (entry_ids.length == 0) {
      return
    } 
    
    let params = {
      account_id : account.value.id,
      entry_ids : entry_ids
    }

    axios.post(Global.url.api_already_reads_bulk_insert, params).then(res => {
      if (res.data.status == Global.api_status.success) {
        $toast.success("success")
        newNotifications.value = []
        offset.value = 0
        getNotifications()
      }
    }).catch(error=>{
      $toast.error('client error notifications.vue at 262')
      setClientErrors({func:"common/notification.vue::_readEntry", params: params, errorMessage:error})
    })
  }

  /**
   * 
   */
  const _readAllMark = (notifications) => {
    let entries = notifications.filter(x => x.notification_division_id == Global.notification_division_id.mark && x.is_unread === true)
    let entry_ids = entries.map(row => row.id)
    let mark_ids = entries.map(row => row.mark_id)
    let params = {
      account_id : account.value.id,
      entry_ids : entry_ids,
      mark_ids : mark_ids
    }
    axios.post(Global.url.api_already_marks_bulk_insert, params)
    .then(res => {
      if (res.data.status == Global.api_status.success) {
        $toast.success("success")
        newNotifications.value = []
        offset.value = 0
        getNotifications()
      }
    })
    .catch(error=>{
      $toast.error('client error notifications.vue')
      setClientErrors({func:"view/notifications/notifications.vue::_readAllMark", params: params, errorMessage:error})
    })
  }

  return {
    newNotifications,
    createTemporaryAddNotification, 
    getCircleInvites, 
    getNotifications, 
    go, 
    readAll,
  }
}

